export default {
    general: {
        add:      'Add',
        edit:     'Edit',
        cancel:   'Cancel',
        save:      'Save',
        sign_out:  'Sign out',
        more_info: 'More information',   // AppInfoTip's aria-label
        ni_podatkov: 'No data.',
    },
    // Used by the shell templates (step 19)
    brand: {
        product_name: 'Blisk BI',
        tagline:      'Business intelligence',
    },
    nav: {
        group_overviews:    'Overviews',
        overview:           'Overview',
        projects:           'Projects',
        data_quality:       'Data quality',
        revenue_costs:      'Revenue and costs',
        cash_flow:          'Cash flow',
        payment_discipline: 'Payment discipline',
        imports:            'Imports',
        group_bmapp:        'BMapp',
        project_progress:   'Project progress',
        teams:              'Teams',
        sales:              'Sales',
        group_projects:     'Projects',
        margin:             'Project margin',
        links:              'Project links',
    },
    layout: {
        open_menu:  'Open menu',
        close_menu: 'Close menu',
    },
    color_mode: {
        switch_to_light: 'Switch to light mode',
        switch_to_dark:  'Switch to dark mode',
    },
    errors: {
        generic_error: 'An error occurred',
        invalid_data:  'Invalid data',
        not_found:     'Not found',
        unauthorized:  'Unauthorized',
        neveljaven_izvoz: 'Invalid export',
        ni_podatkov:   'No data',
        ni_dostopa:    'No access',
        prevec_zahtevkov: 'Too many requests, try again later',
        bmapp_izklopljen: 'BMapp data is not available',
        nastavitve_spremenjene: 'The settings were changed by another user in the meantime, refresh.',
        povezava_spremenjena: 'The project link was changed by another user in the meantime, refresh.',
        sn_ze_povezan: 'Cost unit {sn} is already linked to another project.',
        sn_ze_povezan_splosno: 'The selected cost unit is already linked to another project.',
        neveljavna_datoteka: 'File “{ime}” is not an .xlsx export',
        prevelika_datoteka: 'File “{ime}” is too large (max {najvec})',
        prevelika_zahteva: 'The selected files are too large together (max {najvec})',
        on_add:        'Error while adding',
        on_edit:       'Error while updating',
    },
    success: {
        add:  'Successfully added',
        edit: 'Successfully updated',
    },
    validation: {
        required: 'This field is required',
        email:    'Invalid email address',
    },
    prijava: {
        naslov:   'Sign in',
        z_bmapp:  'Sign in with BMapp',
        koncujem: 'Completing sign-in …',
        napaka:   'Sign-in failed. Please try again.',
        prevec_poskusov: 'Too many sign-in attempts. Try again in a minute.',
    },
    ni_dostopa: {
        naslov:   'No access',
        besedilo: 'You do not have access to BI. If you need it, contact Jaka Banič.',
    },
    // ERP export names (README, "Tedenski uvoz"); English wording is a translation
    viri: {
        pokalkulacija_dn:     'DN overview – costing',
        pregled_konta:        'Account overview',
        kartica_kupcev:       'Customer account card',
        kartica_dobaviteljev: 'Supplier account card',
        bmapp_projekti:       'BMapp – projects',
        bmapp_zasedenost:     'BMapp – occupancy',
        bmapp_uspesnost:      'BMapp – bid outcomes',
    },
    vir_izvozov: {
        vrstica: '{vir}: {datoteka} (imported {datum})',
        manjka:  'No import yet for {vir} — the data is incomplete.',
    },
    // Table pages (phase C1.4). The English wording is a translation.
    projekti: {
        samo_najvecji: 'Top {n} only',
        info: 'Result (GL) uses the material from the general ledger (the true figure), result (WO) the material from work orders. Labour is hours × hourly rate.',
        stolpci: {
            sn:                 'Project (SN)',
            naziv:              'Name',
            stevilo_dn:         'Work orders (no.)',
            izdani_racuni:      'Invoices issued',
            material_gk:        'Material (GL)',
            material_dn:        'Material (WO)',
            razlika_materiala:  'Material difference',
            delo:               'Labour',
            tuje_storitve:      'External services',
            ostalo:             'Other',
            rezultat_gk:        'Result (GL)',
            rezultat_dn:        'Result (WO)',
            porabljene_ure:     'Hours spent',
            pogodbena_vrednost: 'Contract value',
        },
    },
    kakovost: {
        skupaj: 'Total',
        sn_samo_gk: {
            naslov: 'Projects only in the general ledger',
            info:   'Projects with at least one ledger entry that appear in no work-order row (including overhead).',
        },
        sn_samo_dn: {
            naslov: 'Projects only in work orders',
            info:   'Projects in work orders (excluding overhead) with no ledger entries.',
        },
        razlike_materiala: {
            naslov: 'Material differences WO ↔ GL',
            info:   'Projects whose material differs by at least 1 cent, ordered by the size of the difference.',
        },
        stroski_brez_sn: {
            naslov: 'Costs without a project',
        },
        cena_ure_odstopa: {
            naslov: 'Hourly rate deviates',
            info:   'Work orders where labour is not equal to hours × hourly rate (deviation of more than 1 cent).',
        },
        stolpci: {
            sn:          'Project (SN)',
            naziv:       'Name',
            stroski:     'Costs',
            prihodki:    'Revenue',
            material_gk: 'Material (GL)',
            material_dn: 'Material (WO)',
            razlika:     'Difference',
            konto:       'Account',
            znesek:      'Amount',
            dn:          'Work order',
            delo:        'Labour',
            ure:         'Hours',
            cena_ure:    'Hourly rate',
        },
    },
    prihodki_stroski: {
        rezultat_po_mesecih: 'Result by month',
        rezultat_po_mesecih_sm: 'Result by month ({sm})',
        sm_oznaka: 'SM {sm}',
        info:    'Revenue is accounts 76xx, costs are class 4 — this is not operating profit (EBIT).',
        sm:      'Cost centre',
        vse:     'All',
        brez_sm: 'No cost centre',
        skupaj:  'Total',
        stolpci: {
            mesec:    'Month',
            sm:       'Cost centre',
            prihodki: 'Revenue (76xx)',
            stroski:  'Costs (class 4)',
            razlika:  'Difference',
        },
    },
    denarni_tok: {
        prilivi_in_odlivi: 'Inflows and outflows by week',
        info:    'Actual payments from account cards; manual settlements (PIFA) are not included. This is not a forecast.',
        skupaj:  'Total',
        stolpci: {
            teden:   'Week (CW)',
            od:      'From',
            prilivi: 'Inflows',
            odlivi:  'Outflows',
            neto:    'Net',
        },
    },
    disciplina: {
        info:        'Only payments that match exactly one invoice. Negative days = paid before the due date. Ageing of open items will come with the open-items export.',
        kupci:       'Customers',
        dobavitelji: 'Suppliers',
        povezanih:   'Matched payments',
        mediana:     'Median days from due date',
        p25:         'P25 (days)',
        p75:         'P75 (days)',
        delez:       'Share paid after due date',
    },
    uvozi: {
        preberi:        'Read folder now',
        osvezi_bmapp:   'Refresh from BMapp',
        osvezi_uspelo:  'Refreshed from BMapp: successful {uspesnih}, errors {napak}',
        osvezi_napake:  'BMapp refresh: errors {napak} (see the imports table)',
        preberi_uspelo: 'Imported: {uvozenih}, skipped: {preskocenih}, errors: {napak}',
        nalozi:         'Upload exports',
        prevec_datotek: 'You can upload at most {najvec} files at once',
        povzetek_naslov: 'Uploading exports',
        povzetek:       'Imported: {uvozenih}, already imported: {preskocenih}, errors: {napak}',
        nacin: {
            mapa:      'Folder',
            nalaganje: 'Uploaded',
        },
        stanje: {
            v_teku:  'In progress',
            uspesno: 'Successful',
            napaka:  'Error',
        },
        stolpci: {
            uvozeno:  'Imported',
            vir:      'Source',
            datoteka: 'File',
            vrstic:   'Rows',
            stanje:   'Status',
            napaka:   'Error',
            nacin:    'Method',
            nalozil:  'Uploaded by',
        },
    },
    // BMapp pages (phase F1)
    bmapp: {
        ni_prebrano:     'BMapp data has not been read yet.',
        stanje:          'BMapp state: {datum}',
        odrezano:        'The bid list is truncated: only the outcomes that were read are shown, the data is incomplete.',
        skupaj:          'Total',
        ne_osvezuje:     'BMapp is not configured: the data is not being refreshed.',
    },
    napredek: {
        info:            'Project progress from BMapp: active projects (in preparation, in progress). End by team accounts for team availability, end by pace for the efficiency achieved so far.',
        portfelj:        'Portfolio',
        portfelj_info:   'Unfinished = sum of max(0, planned − completed) over active projects. Monthly capacity = average weekly availability over 12 weeks × 52 / 12. Months of work = expected hours / monthly capacity.',
        predlog:         'proposed definition, to be confirmed by Simona',
        neopravljeno:    'Unfinished',
        pricakovane_ure: 'Expected hours',
        meseci_dela:     'Months of work',
        brez_napovedi:   'Projects without forecast',
        vir_zasedenosti: 'Occupancy for the portfolio: {datum}',
        brez_zasedenosti:'Portfolio is not calculated: BMapp occupancy has not been read yet.',
        stolpci: {
            sifra:         'Code',
            naziv:         'Name',
            stranka:       'Customer',
            vodja:         'Manager',
            rok:           'Deadline',
            napredek:      'Progress',
            nacrtovano:    'Planned',
            opravljeno:    'Completed',
            obracunano:    'Invoiced',
            nezaracunano:  'Not invoiced',
            konec_ekipa:   'End by team',
            rezerva_ekipa: 'Margin by team',
            rezerva_tempo: 'Margin by pace',
            konec_tempo:   'End by pace',
        },
        rezerva_dni:     '{n} d',
        vrednost:        'value',
        norma:           'norm',
        ure:             'hours',
    },
    ekipe: {
        izkoriscenost_po_tednih: 'Utilisation by week',
        info:            'Utilisation = assigned / available. Available is working days without holidays and approved leave.',
        tednov:          'Number of weeks',
        tednov_n:        '{n} weeks',
        manjka_tednov:   'BMapp returned fewer weeks than selected: {dobljeno} of {izbrano}.',
        po_tednih:       'Team by week',
        po_osebah:       'People by week',
        stolpci: {
            teden:          'Week',
            razpolozljivo:  'Available',
            dodeljeno:      'Assigned',
            izkoriscenost:  'Utilisation',
            brez_dodelitve: 'Unassigned',
            oseba:          'Person',
            povprecje:      'Average',
        },
    },
    prodaja: {
        info:            'Bid outcomes by month of outcome. Share = won / (won + lost); "we do not submit" is not counted.',
        stolpci: {
            mesec:                'Month',
            dobljenih:            'Won',
            izgubljenih:          'Lost',
            ne_oddamo:            'Not submitted',
            delez:                'Share won',
            vrednost_dobljenih:   'Value won',
            vrednost_izgubljenih: 'Value lost',
        },
    },
    // Custom SVG charts (phase C2.5): screen reader descriptions and traffic-light texts.
    grafi: {
        ni_podatka:         'no data',
        ni_podatkov:        'No data.',
        povzetek:           'From {od} to {do}: {n} points. First {prva}, last {zadnja}, lowest {najnizja} ({kdajNajnizja}), highest {najvisja} ({kdajNajvisja}).',
        brez_podatka_stevilo: 'Points without data: {n}.',
        legenda:            'Legend',
        navigacija:         'Left and right arrow keys move the selected point.',
        semafor: {
            zelena: 'green',
            rumena: 'yellow',
            rdeca:  'red',
            brez:   'no threshold',
        },
    },
    // Front page (phase C2.6): names and descriptions of the catalogue indicators (`pkg/Kazalniki/katalog.go`) by id.
    kazalniki: {
        rezultat_leto: {
            ime:  'Result of the current year',
            opis: 'Difference between revenue (accounts 76xx) and class 4 costs of the current year. This is not EBIT.',
        },
        prihodki_leto: {
            ime:  'Revenue of the current year',
            opis: 'Sum of the current year revenue.',
        },
        stroski_leto: {
            ime:  'Costs of the current year',
            opis: 'Sum of the current year costs.',
        },
        prilivi_4_tedni: {
            ime:  'Inflows of the last 4 weeks',
            opis: 'Sum of inflows of the last 4 completed weeks.',
        },
        odlivi_4_tedni: {
            ime:  'Outflows of the last 4 weeks',
            opis: 'Sum of outflows of the last 4 completed weeks.',
        },
        stroski_brez_dn: {
            ime:  'Costs without a work order',
            opis: 'Class 4 costs without a work order code (SN); a bookkeeping quality indicator. The amount covers the whole imported account overview, not only the current year (as on the Data quality page).',
        },
        napredek_skupaj: {
            ime:  'Progress of projects in progress',
            opis: 'Sum of completed work divided by the sum of planned work for projects in progress.',
        },
        nezaracunano: {
            ime:  'Not yet invoiced',
            opis: 'Sum of not yet invoiced amounts of projects in progress.',
        },
        portfelj_neopravljeno: {
            ime:  'Portfolio: remaining work',
            opis: 'Remaining work (value) of projects in preparation and in progress. Proposed definition, not yet confirmed.',
        },
        portfelj_meseci: {
            ime:  'Portfolio: months of work',
            opis: 'Months of work in the portfolio relative to the monthly team capacity. Proposed definition, not yet confirmed.',
        },
        izkoriscenost_4_tedni: {
            ime:  'Utilisation of the next 4 weeks',
            opis: 'Sum of assigned time divided by the sum of available time in the next 4 weeks.',
        },
        delez_dobljenih_12m: {
            ime:  'Share of won bids (12 months)',
            opis: 'Won divided by the sum of won and lost in the last 12 months.',
        },
        projekti_negativna_rezerva: {
            ime:  'Projects with negative slack',
            opis: 'Number of projects in progress with team-based slack below zero; without a team-based forecast the pace-based slack applies.',
        },
        projekti_v_rdecem: {
            ime:  'Projects in the red',
            opis: 'Number of projects whose expected final margin (share of the planned value) is below the "project in the red" threshold; without a threshold there is no value. Proposed definition, not confirmed yet.',
        },
        marza_pricakovana_skupaj: {
            ime:  'Expected margin overall',
            opis: 'Sum of expected final margins divided by the sum of planned values of projects linked to cost units that have an expected margin. Proposed definition, not confirmed yet.',
        },
    },
    // Front page: cards, editing and change history.
    pregled: {
        uredi:          'Edit front page',
        zgodovina:      'Change history',
        prazno:         'The front page has no cards. Add them with "Edit front page".',
        nalaganje:      'Loading the front page …',
        predlog:        'proposed definition',
        razlog_bmapp:   'BMapp data has not been read yet',
        razlog_erp:     'No ERP export imported',
        razlog_bmapp_erp: 'BMapp projects, the work-order cost report or the account ledger are missing',
        razlog_izracun: 'The value cannot be calculated',
        stanje:         'As of {datum}',
        odgovoren:      'Responsible: {ime}',
        trend:          'Trend: {ime}',
        info_enota:     'Unit: {enota}',
        info_vir:       'Source: {vir}',
        info_smer:      'Direction: {smer}',
        enote: {
            centi:           'euros',
            bp:              'percent',
            tisocinke_ure:   'hours',
            stevilo:         'count',
            stotinke_meseca: 'months',
        },
        viri: {
            erp:       'ERP exports',
            bmapp:     'BMapp',
            bmapp_erp: 'BMapp and ERP exports',
        },
        smer: {
            visje: 'higher is better',
            nizje: 'lower is better',
        },
        urejanje: {
            naslov:         'Edit front page',
            kartice:        'Cards',
            brez_kartic:    'No cards. Add an indicator.',
            gor:            'Move up',
            dol:            'Move down',
            odstrani:       'Remove card',
            odgovoren:      'Responsible',
            cilj:           'Target',
            meja_rdece:     'Red limit',
            predogled:      'Colour preview',
            primer:         'e.g. {vrednost}',
            brez_vrednosti: 'Without a current value the indicator has no colour.',
            dodaj_naslov:   'Add indicator',
            dodaj_izberi:   'Choose an indicator',
            dodaj:          'Add',
            vsi_dodani:     'All indicators are already on the page.',
            najvec_kartic:  'At most {n} cards.',
            shranjeno:      'The front page is saved.',
            napaka_preveri: 'Correct the marked fields.',
            meja_projekta:      'Project in the red threshold (%)',
            meja_projekta_info: 'A project is in the red when its expected final margin (share of the planned value) is below this threshold. Empty: no threshold and no projects in the red. The definition is a proposal.',
            meja_projekta_napaka: 'Enter a share between 0 and 100 % or leave it empty.',
        },
        napake: {
            predolg:    'At most {n} characters.',
            neveljavno: 'Invalid value.',
            skupaj:     'Target and red limit must both be filled in or both left empty.',
            visje:      'With "higher is better" the target must be above the red limit.',
            nizje:      'With "lower is better" the target must be below the red limit.',
            smer:       'Unknown indicator direction.',
        },
        zgodovina_stran: {
            naslov:         'Change history',
            prazno:         'No recorded changes.',
            dodana:         'Card "{ime}" added',
            odstranjena:    'Card "{ime}" removed',
            vrstni_red:     'Card order changed',
            odgovoren:      '"{ime}": responsible {prej} → {potem}',
            ni_odgovornega: 'not set',
            meje:           '"{ime}": limits {prej} → {potem}',
            meje_oblika:    'target {cilj}, red limit {meja}',
            brez_mej:       'no limits',
            brez_razlik:    'No substantive changes (saved unchanged)',
            verzija:        'version {n}',
            meja_projekta:  'Project in the red threshold {prej} → {potem}',
            brez_meje:      'no threshold',
        },
    },
    // Project margin (proposed definitions).
    marza: {
        info:       'Planned margin = initial (contract) value − planned costs (BMapp estimate: material at purchase price + effective hours × hourly rate; otherwise the ERP work-order plan). Achieved to date = invoices issued − actual costs of linked cost units (material from the ledger + labour + external services + other). Expected final costs = actual + planned × (1 − progress by value); expected margin = planned value − expected costs.',
        predlog:    'Definitions are a proposal — to be confirmed by Simona',
        meja:       'Project in the red threshold: {meja}',
        brez_meje:  'The project in the red threshold is not set, so no project is in the red. Set it when editing the front page.',
        uredi_mejo: 'Edit front page',
        povzetek: {
            povezanih:     'Linked',
            brez_povezave: 'Not linked',
            v_rdecem:      'In the red',
            brez_plana:    'No plan',
        },
        stolpci: {
            sifra:       'Code',
            naziv:       'Name',
            vir_plana:   'Plan source',
            planirana:   'Planned margin',
            dosezena:    'Achieved to date',
            napredek:    'Progress',
            pricakovana: 'Expected margin',
            opozorila:   'Warnings',
        },
        vir_plana: {
            kalkulacija: 'BMapp estimate',
            plan_dn:     'ERP work-order plan',
            brez:        'No plan',
        },
        v_rdecem: 'In the red',
        opozorila: {
            zacet_pred_izvozi:       'Before 2026',
            nepredvidena_brez_plana: 'Unforeseen work',
            plan_delen:              'Partial plan',
            brez_povezave_sn:        'No cost unit',
            sn_ni_v_uvozu:           'Cost unit not imported',
        },
        opozorila_info: 'Before 2026: started before 1 Jan 2026, ERP actual costs may be incomplete. Unforeseen work: the plan does not include it. Partial plan: the estimate has manual or unestimated items. No cost unit: not linked, actual costs are unknown. Cost unit not imported: a linked cost unit is missing from the latest work-order cost report, actual costs exclude it.',
        projekti:       'Projects',
    },
    // Project links BMapp ↔ cost units.
    povezave: {
        info: 'Links a BMapp project to cost units in the ERP. The system suggests, a user confirms; every change is recorded.',
        zavihki: {
            projekti: 'BMapp projects',
            sn:       'Cost units without a project',
        },
        stolpci: {
            sifra:    'Code',
            naziv:    'Name',
            stranka:  'Customer',
            sn:       'Cost units',
            stanje:   'State',
            sn_sifra: 'Cost unit',
            naziv_sn: 'Cost unit name',
            izdani:   'Invoices issued',
            stroski:  'Costs',
        },
        stanje: {
            povezan: 'Linked',
            predlog: 'Suggestion',
            brez:    'Not linked',
        },
        dialog: {
            naslov:           'Project link {sifra}',
            info:             'A suggestion (score by name, value and year) is only a suggestion; a cost unit is linked only when you confirm. One cost unit can be linked to at most one project.',
            predlogi:         'Suggestions',
            brez_predlogov:   'No suggestions.',
            ocena:            'score {ocena}',
            razlogi: {
                naziv:    'name',
                vrednost: 'value',
                leto:     'year',
            },
            iskanje:          'Search cost unit or name',
            iskanje_prazno:   'No matches.',
            izbrani:          'Selected cost units',
            brez_izbranih:    'No cost units selected.',
            dodaj:            'Add',
            odstrani:         'Remove',
            povezan_drugje:   'linked to {sifra}',
            potrdi:           'Confirm',
            odvezi:           'Unlink all',
            shranjeno:        'The link has been saved.',
            zgodovina:        'Change history',
            zgodovina_prazno: 'No changes recorded.',
            dodan:            'added {sn}',
            odstranjen:       'removed {sn}',
        },
    },
}
